module.exports = __webpack_public_path__ + "src/assets/games/10/318.jpg";